import { LoginForm } from "@/components/login-form";

export default function LoginPage() {
    return (
        <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
            <div className="w-full max-w-sm flex flex-col gap-8">
                <img alt="Logo" src="/logo_text.png" />
                <LoginForm />
            </div>
        </div>
    );
}
